// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__7FVAk","author":"Table_author__3seIL","authorImage":"Table_authorImage__1rdDG","unreadRow":"Table_unreadRow__3RPow"};